/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_View_Original_PostingInputs */

const en_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View original posting`)
};

const de_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalanzeige ansehen`)
};

const fr_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'offre originale`)
};

const es_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver oferta original`)
};

const it_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi annuncio originale`)
};

const nl_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk originele vacature`)
};

const pl_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz oryginalne ogłoszenie`)
};

const fi_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä alkuperäinen ilmoitus`)
};

const da_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se originalt opslag`)
};

const sv_jobs_view_original_posting = /** @type {(inputs: Jobs_View_Original_PostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa originalannons`)
};

/**
* | output |
* | --- |
* | "View original posting" |
*
* @param {Jobs_View_Original_PostingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_view_original_posting = /** @type {((inputs?: Jobs_View_Original_PostingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_View_Original_PostingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_view_original_posting(inputs)
	if (locale === "fr") return fr_jobs_view_original_posting(inputs)
	if (locale === "es") return es_jobs_view_original_posting(inputs)
	if (locale === "it") return it_jobs_view_original_posting(inputs)
	if (locale === "nl") return nl_jobs_view_original_posting(inputs)
	if (locale === "pl") return pl_jobs_view_original_posting(inputs)
	if (locale === "fi") return fi_jobs_view_original_posting(inputs)
	if (locale === "da") return da_jobs_view_original_posting(inputs)
	if (locale === "sv") return sv_jobs_view_original_posting(inputs)
	return en_jobs_view_original_posting(inputs)
});